(function() {
  "use strict";

  angular.module("app").filter("reverse", function() {
    return function(items) {
      return Array.isArray(items) ? items.slice().reverse() : items;
    };
  });
})();
